// src/events/EventProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getEventsSession } from "./session";

export default function EventProtectedRoute({ children }) {
  const session = getEventsSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/events/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
